import { Button, Text } from '../../../..'
import { WizardButtonGroup } from '../Button'
import { useIntl, defineMessages } from 'react-intl'
import { useSelector, useDispatch } from 'react-redux'
import { MonthPicker } from '../../../../shared/MonthPicker'
import { saveClientAnswer } from '../../../../../actions/client'
import { add, format, isSameMonth, startOfMonth } from 'date-fns'
import { RangeDatePicker } from '../../../../shared/RangeDatePicker'
import { useWizardProvider } from '../../../../shared/WizardContext'
import { useTrackingContext } from '../../../../../providers/tracking'
import { selectAnswerDate } from '../../../../../store/selectors/client'
import { QUESTION_DATE } from '../../../../../constants/client/onboarding'

import baseStyles from '../../BuyerOnboardingWizard.module.scss'
import styles from './EnterCloseDate.module.scss'
import { BUYER_DIGEST_ONBOARDING_WIZARD_CLOSE_DATE } from '../../../../../constants/tracking/trackingEventLocations/buyerDigestTrackingEventLocation'

export const MSG = defineMessages({
  headline: {
    id: 'NewBuyerOnboarding.closeDateStep.headline',
    defaultMessage: 'When are you hoping to close by?'
  },
  soonLabel: {
    id: 'NewBuyerOnboarding.closeDateStep.soonLabel',
    defaultMessage: 'As soon as possible'
  },
  laterLabel: {
    id: 'NewBuyerOnboarding.closeDateStep.laterLabel',
    defaultMessage: "I'm not in a rush"
  },
  cont: {
    id: 'NewBuyerOnboarding.buttonGroup.continue',
    defaultMessage: 'Continue'
  },
  skip: {
    id: 'NewBuyerOnboarding.buttonGroup.skip',
    defaultMessage: 'Skip for now'
  }
})

export const EnterCloseDate = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const { trackingClient } = useTrackingContext()
  const { goBack, goForward } = useWizardProvider()
  const closeDate = useSelector(selectAnswerDate) || null
  const nextMonth = startOfMonth(add(new Date(), { months: 1 }))

  const saveCloseDate = index => {
    const date = startOfMonth(add(nextMonth, { months: index }))

    trackingClient?.buyerOnboarded({
      close_timeline: format(date, 'MMM').toLowerCase()
    })
    dispatch(
      saveClientAnswer({
        question: QUESTION_DATE,
        response: {
          value: format(date, 'yyyy-MM-dd')
        }
      })
    )
    setTimeout(() => {
      goForward() // Slow down transition see highlighting over choice before next screen
    }, 500)
  }

  return (
    <div data-qa='enter-close-date' className={baseStyles.step}>
      <div>
        <Text.Headline>{intl.formatMessage(MSG.headline)}</Text.Headline>
      </div>
      <div className={styles.pickerContainer}>
        <RangeDatePicker closeMonth={closeDate} startMonth={nextMonth} onChange={saveCloseDate} />
        <div className={styles.pickerLabels}>
          <Text className={styles.label} variant='neutralCool' variantCount='600' size='s'>
            {intl.formatMessage(MSG.soonLabel)}
          </Text>
          <Text className={styles.label} variant='neutralCool' variantCount='600' align='right' size='s'>
            {intl.formatMessage(MSG.laterLabel)}
          </Text>
        </div>
      </div>
      <MonthPicker
        startMonth={nextMonth}
        onClick={saveCloseDate}
        className={styles.monthPicker}
        isSelected={month => isSameMonth(month, closeDate)}
        tracking={{
          guid: 'v59DuPxzKCmYt8BmycAh8e',
          ui_context: BUYER_DIGEST_ONBOARDING_WIZARD_CLOSE_DATE
        }}
      />
      <WizardButtonGroup>
        <Button.Back onClick={goBack} />
        <Button.Forward className={baseStyles.continue} onClick={goForward}>
          {intl.formatMessage(closeDate ? MSG.cont : MSG.skip)}
        </Button.Forward>
      </WizardButtonGroup>
    </div>
  )
}
